export default __webpack_public_path__ + "static/Gem_hunter-b215d24bbeba29f035c33e0802ef0776.png";